module.exports = require("./ff-Latn-NE");